import { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import storageService from '../services/storage.service'

interface LogoutProps extends RouteComponentProps {}

class Logout extends Component<LogoutProps> {
  logout () {
    storageService.remove('authToken')
    this.props.history.push(routes.signIn)
  }

  componentDidMount () {
    this.logout()
  }

  render () {
    return null
  }
}

export default withRouter(Logout)
